// mixin.js
const IframeMixin = {
    data() {
        return {
            isChecked: false
        };
    },
    computed: {
        isConfirmedTechnician: {
            get() {
                return this.$store.state.schedules.confirm_technician;
            },
            set(value) {
                this.$store.commit('schedules/confirmTechnician', value)
            }
        },
        isConfirmedClient: {
            get() {
                return this.$store.state.schedules.confirm_client;
            },
            set(value) {
                this.$store.commit('schedules/confirmClient', value)
            }
        },
    },
    methods: {

    }
};

export default IframeMixin;
